import * as Scrivito from "scrivito";

const LinksFooterWidget = Scrivito.provideWidgetClass("LinksFooterWidget", {
  onlyInside: "FooterContainerWidget",
  attributes: {
    title: "string",
    links: "linklist",
  },
  extractTextAttributes: ["title"],
});

export default LinksFooterWidget;
